import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

interface SnackbarData {
  message: string;
  type: 'success' | 'error';
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-snackbar',
  imports: [CommonModule],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss',
})
export class ReusableSnackbarComponent {
  icon: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData) {
    this.icon = this.getIcon(data.type);
  }

  getIcon(type: SnackbarData['type']): string {
    switch (type) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'error';
    }
  }
}
